import batchLoad from 'global/common/batch-load'
import { mapGetters } from 'vuex';
const token = localStorage.getItem('token')
//if (token == null) throw new Error('Пользователь не авторизован');

const tables = ['sup_contract_status', 'sup_priority', 'sup_source', 'sup_status', 'sup_task', 'sup_user']
import mapClassifier from 'global/common/mapClassifier'
export default {
    state: {
        supportLoaded: false,
        supportDict: Object.fromEntries(tables.map(row => [row, []])),
        config(ctx) {
            return {
                headers(row) {
                    return {
                        Authorization: token,
                        'Table-Type': row
                    }
                },
                onComplete({ row, response }) {
                    ctx.commit('setValue', { row, result: response.data.Data })
                },
                onError({ row, reason }) {
                    console.error(reason);
                },
                onBatchComplete(resolved) {
                    ctx.commit('changeSupportLoadStatus', true)
                }
            }
        }
    },
    actions: {
        retrieve(ctx) {
            if (ctx.state.supportLoaded) return Promise.resolve(ctx.supportDict);
            return batchLoad(tables, (row) => `/${row}`, 50, ctx.state.config(ctx))
        }
    },
    mutations: {
        setValue(state, { row, result }) {
            state.supportDict[row] = result
        },

        changeSupportLoadStatus(state, status) {
            state.supportLoaded = status
        },
    },
    getters: {
        ...mapClassifier(tables, 'supportDict'),
        getSourceByID(state) {
            return (source_id) => {
                return state.supportDict.sup_source.find(f => f.source_id === source_id)
            }
        },
        getStatusByID(state) {
            return (status_id) => {
                return state.supportDict.sup_status.find(f => f.status_id === status_id)
            }
        },
        getTaskByID(state) {
            return (task_id) => {
                return state.supportDict.sup_task.find(f => f.task_id === task_id)
            }
        },
        getPriorityByID(state) {
            return (priority_id) => {
                return state.supportDict.sup_priority.find(f => f.priority_id === priority_id)
            }
        },
        isSupportLoaded(state) {
            return state.supportLoaded
        }
    }
}